// extracted by mini-css-extract-plugin
export default {"content-section":"content-section--ujzp","preloader":"preloader--df6b"};